import base from "/Users/lone/Desktop/monochrome/images/facebook.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");